<template>
  <div class="card-wrapper">
    <b-card v-for="product in hitProducts" :key="product.id" class="mb-3">
      <div class="d-xs-flex justify-content-between align-items-center">
        <div class="d-lg-flex d-block flex-grow-1">
          <p class="card-text w-100 mb-lg-0 mb-2 mr-2">
            {{ product.name }}
          </p>
        </div>

        <div class="actions d-flex justify-content-end mt-xs-0 mt-4">
          <i @click="showInfoModal(product.id)" class="glyph-icon simple-icon-pencil datalist-icon mr-md-3 mr-2"></i>

          <i @click="handleDelete(product.id)" class="glyph-icon simple-icon-trash datalist-icon"></i>
        </div>
      </div>
    </b-card>

    <!-- Modals -->
    <b-modal id="editSingleHitProductModal" ref="editSingleHitProductModal" size="lg" :title="'Edit Product'">
      <b-row v-if="!isLoading">
        <b-colxx xxs="12">
          <b-card class="mb-4">
            <b-form @submit.prevent="onSubmit" class="av-tooltip">
              <b-form-group :label="$t('anyform.selectImage')">
                <b-form-file
                  v-model="editForm.image"
                  accept="image/*"
                  @change="imageUploaded = !imageUploaded"
                ></b-form-file>
              </b-form-group>

              <div class="my-2 mb-4">
                <img
                  v-if="!imageUploaded && imageUrl !== null"
                  :src="`${apiUrl}${imageUrl}`"
                  class="object-cover"
                  draggable="false"
                  width="100"
                  height="100"
                  alt=""
                />
              </div>

              <b-form-group :label="$t('pages.sliders.link')">
                <b-form-input type="text" v-model="$v.editForm.link.$model" :state="!$v.editForm.link.$error" />
                <b-form-invalid-feedback v-if="!$v.editForm.link.required">
                  {{ $t('formErrors.enterLink') }}
                </b-form-invalid-feedback>
              </b-form-group>

              <b-form-group :label="`${$t('anyform.productName')} (EN)`">
                <b-form-input type="text" v-model="$v.editForm.name_en.$model" :state="!$v.editForm.name_en.$error" />
                <b-form-invalid-feedback v-if="!$v.editForm.name_en.required">
                  {{ $t('formErrors.enterName') }}
                </b-form-invalid-feedback>
              </b-form-group>

              <b-form-group :label="`${$t('anyform.productName')} (RU)`">
                <b-form-input type="text" v-model="$v.editForm.name_ru.$model" :state="!$v.editForm.name_ru.$error" />
                <b-form-invalid-feedback v-if="!$v.editForm.name_ru.required">
                  {{ $t('formErrors.enterName') }}
                </b-form-invalid-feedback>
              </b-form-group>

              <b-form-group :label="$t('pages.products.price')">
                <b-form-input type="text" v-model="$v.editForm.price.$model" :state="!$v.editForm.price.$error" />
                <b-form-invalid-feedback v-if="!$v.editForm.price.required">
                  {{ $t('formErrors.enterPrice') }}
                </b-form-invalid-feedback>
              </b-form-group>

              <b-button
                type="submit"
                variant="primary"
                :disabled="isLoading"
                :class="{
                  'btn-multiple-state mt-2': true,
                  'show-spinner': isLoading
                }"
              >
                <span class="spinner d-inline-block">
                  <span class="bounce1"></span>
                  <span class="bounce2"></span>
                  <span class="bounce3"></span>
                </span>
                <span class="label">
                  {{ $t('buttons.save') }}
                </span>
              </b-button>
            </b-form>
          </b-card>
        </b-colxx>
      </b-row>
      <div v-else class="d-flex justify-content-center">
        <b-spinner variant="primary" label="Loading..."></b-spinner>
      </div>

      <template slot="modal-footer">
        <b-button variant="secondary" @click="hideModal('editSingleHitProductModal')">
          {{ $t('buttons.cancel') }}
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { apiUrl } from '@/constants/config'
const { required } = require('vuelidate/lib/validators')

export default {
  props: {
    hitProducts: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      apiUrl,
      isLoading: false,
      imageUrl: null,
      imageUploaded: false,
      editForm: {
        name_en: '',
        name_ru: '',
        link: '',
        price: '',
        image: null
      },
      currentHitProduct: null
    }
  },
  validations: {
    editForm: {
      link: { required },
      name_en: { required },
      name_ru: { required },
      price: { required }
    }
  },
  mounted() {
    this.$root.$on('bv::modal::show', (_bvEvent, modalId) => {
      if (modalId === 'editSingleHitProductModal') {
        this.clearForm()
      }
    })
  },
  methods: {
    addNotification(type, title, message) {
      this.$notify(type, title, message, { duration: 3000, permanent: false })
    },
    handleDelete(id) {
      this.$confirm({
        message: this.$t('confirm-dialog.question'),
        button: {
          no: this.$t('confirm-dialog.no'),
          yes: this.$t('confirm-dialog.yes')
        },
        callback: (confirm) => {
          if (confirm) {
            this.$store.dispatch('hitProducts/deleteSingleHitProduct', {
              id,
              vm: this
            })
          }
        }
      })
    },
    showInfoModal(id) {
      this.$bvModal.show('editSingleHitProductModal')
      this.$store.dispatch('hitProducts/fetchSingleHitProduct', {
        id,
        vm: this
      })
      this.currentHitProduct = id
    },
    onSubmit() {
      this.$v.$touch()
      if (!this.$v.$invalid) {
        const payload = {
          name_en: this.editForm.name_en,
          name_ru: this.editForm.name_ru,
          link: this.editForm.link,
          price: this.editForm.price
        }

        if (this.editForm.image) {
          payload.image = this.editForm.image
        }

        this.$store.dispatch('hitProducts/updateSingleHitProduct', {
          payload,
          id: this.currentHitProduct,
          vm: this
        })
      }
    },
    clearForm() {
      this.editForm.link = ''
      this.editForm.name_en = ''
      this.editForm.name_ru = ''
      this.editForm.price = ''
      this.editForm.image = null
      this.imageUrl = null
      this.imageUploaded = false
      this.currentHitProduct = null
    },
    hideModal(refname) {
      this.$refs[refname].hide()
    }
  }
}
</script>
